define('controllers/externalaccountinsert',['require'],function(require) {
    return function() {
        window.checksum = function (source, routingNumber) {
            var routlist = new Array(routingNumber.Value.length);
            var checksum;

            // Create an array containing each of the characters in the passed routing number
            for (i = 0; i < routlist.length; i++) {
                routlist[i] = Number(routingNumber.Value.charAt(i));
            }


            //Return the math.  Calculate checksum and compair to 9th digit (checksum.)
            // d_9 = 7 (d_1 + d_4 + d_7) + 3 (d_2 + d_5 + d_8) + 9 (d_3 + d_6) mod 10
            checksum = (7 * (routlist[0] + routlist[3] + routlist[6]) + 3 * (routlist[1] + routlist[4] + routlist[7]) + 9 * (routlist[2] + routlist[5])) % 10;

            routingNumber.IsValid = routlist[8] == checksum;

        }

        $(".routingNumber").off("change").on("change", function () {
            var $this = $(this),
                context = $this.parent().parent().parent(),
                clientMsg = $(".clientMsg", context.parent().parent());

            clientMsg.hide();
            $.ajax({
                type: 'POST',
                url: "/Public/BankLookupAJAX.aspx",
                data: { RoutingNumber: $this.val() },
                success: function (bankName) {
                    if (bankName.trim().length > 0) {
                        $(".bankName", context).val(bankName);
                    } else {
                        Utilities.setInfo("We couldn't find your bank in our system. Please double check that the routing number you entered is correct.", clientMsg);
                    }
                }
            });
        });

        $(".btnVerify").on("click", function (e) {
            $(this).hide().next().show(); //.prop('disabled', true); --disabling stops default action...
        });

        //validate clientside stuff when external account save is clicked
        $.each(window.ServerData.feData.externalaccountinsertdata, function(i, item) {
            $("#{0}".format(item.buttonsaveclientid)).on("click", function (e) {
                var valid = (window.Page_ClientValidate == undefined || Page_ClientValidate(item.ValidationGroup));
                if (valid) {
                    $(this).hide().next().fadeIn('slow');
                } else {
                    e.preventDefault();
                }
            });
        });
    };
});


